import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CSVLink } from 'react-csv'
import moment from 'moment'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

import { Button, Col, Row, Table } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import * as reportTypes from '../../../../redux/types/reportTypes'
import { getMode } from '../../../../functions/globalFunctions'
import { useGetAllNewReturningAnalysis } from '../../../../ReactQueryhooks/reportHooks'
import Header from '../../../../components/Header'
import BackToPreviews from '../../../../components/BackToPreviews'
import NewRetFilterDrawer from '../components/NewRetFilter'

const NewReturningAnalysisList = () => {
  const dispatch = useDispatch()

  const customerMode = localStorage.getItem('customer-mode')
  const allNewReturningAnalysis = useSelector((state) => state.reportReducer.allData)
  const vendorInfo = useSelector((state) => state.generalReducer.vendorInfo)
  // const minDate = localStorage.getItem('minDate')
  const minDate = moment().startOf('month').format('YYYY-MM-DD')
  const [startDate, setStartDate] = useState(minDate ? moment(minDate) : '')
  const [endDate, setEndDate] = useState(moment())
  const [defaultData, setDefaultData] = useState(null)
  const [location, setLocation] = useState(undefined)
  const [filterApplied, setFilterApplied] = useState(false)
  const [tableLoader, setTableLoader] = useState(false)
  const [advenceSerach, setAdvenceSerach] = useState()
  const [newCustomersTotal, setNewCustomersTotal] = useState(0)
  const [returningCustomerTotal, setReturningCustomerTotal] = useState(0)
  const [newCusPerTotal, setNewCusPerTotal] = useState(0)
  const [retCustPerTotal, setRetCusPerTotal] = useState(0)
  const [totalRegCusCount, setTotalRegCusCount] = useState(0)
  const [totalRegTransCount, setTotalRegTransCount] = useState(0)
  const [totalTransCount, setTotalTransCount] = useState(0)
  const [totalTransPercent, setTotalTransPercent] = useState(0)
  const [sortedData, setSortedData] = useState(null)
  const [sortedInfo, setSortedInfo] = useState({})

  const allNewReturningAnalysisMutateState = useGetAllNewReturningAnalysis(dispatch)

  const footerData = [
    ' ',
    `Grand Total`,
    `${newCustomersTotal}`,
    '',
    '',
    `${newCusPerTotal} %`,
    `${returningCustomerTotal}`,
    '',
    '',
    `${retCustPerTotal} %`,
    `${totalRegCusCount}`,
    `${totalRegTransCount}`,
    `${totalTransCount}`,
    `${totalTransPercent} %`,
  ]

  // Function to handle sorting of data
  const handleSort = (columnKey, currentOrder) => {
    const isAscend = currentOrder === 'ascend'
    const nextOrder = isAscend ? 'descend' : 'ascend'

    const sorted = [...defaultData].sort((a, b) => {
      if (
        columnKey === 'newCustomersPercent' ||
        columnKey === 'returningCustomersPercent' ||
        columnKey === 'transactionPercent'
      ) {
        return isAscend
          ? parseFloat(a[columnKey]) - parseFloat(b[columnKey])
          : parseFloat(b[columnKey]) - parseFloat(a[columnKey])
      } else {
        return isAscend ? a[columnKey] - b[columnKey] : b[columnKey] - a[columnKey]
      }
    })

    setSortedInfo({ columnKey, order: nextOrder })
    setSortedData(sorted)
  }

  const exportToPDF = (data, footerData) => {
    const doc = new jsPDF()
    console.log(data)
    console.log('SORTED DATA:', sortedData)
    // Function to add content on each page
    const addContent = () => {
      doc.setFontSize(8)
      doc.text(`${vendorInfo?.vendorName}`, 10, 10)

      doc.setFontSize(8)
      doc.text(`From ${moment(startDate).format('YYYY-MM-DD')}`, 10, 15)

      doc.setFontSize(8)
      doc.text(`To ${moment(endDate).format('YYYY-MM-DD')}`, 10, 20)

      doc.setFontSize(8)
      doc.text(
        `NEW VS RETURNING CUSTOMER ANALYSIS - ${customerMode == 'offline' ? 'OFFLINE' : 'ONLINE'}`,
        doc.internal.pageSize.width / 2,
        10,
        { align: 'center' },
      )

      doc.setFontSize(8)
      doc.text('HANKER', doc.internal.pageSize.width - 10, 10, { align: 'right' })
    }

    const addTableContent = () => {
      autoTable(doc, {
        theme: 'grid',
        head: [
          [
            'Sr.',
            'ShopName',
            'New Cus',
            'New Inv',
            'New Revenue',
            'New Cus %',
            'Ret Cus',
            'Ret Inv',
            'Ret Revenue',
            'Ret Cus %',
            'T. Reg Cus',
            'T. Reg Trans',
            'T. Trans',
            '% of Trans wd No.',
          ],
        ],
        body: sortedData
          ? sortedData?.map((data, index) => {
              return [
                index + 1,
                data?.shopName,
                data?.MobileNew,
                data?.NewInvoices,
                `${(
                  (data?.MobileNew / (data?.MobileNew + data?.MobileReturning)) *
                  100
                ).toLocaleString()} %`,
                data?.MobileReturning?.toLocaleString(),
                data?.ReturningInvoices?.toLocaleString(),
                `${(
                  (data?.MobileReturning / (data?.MobileNew + data?.MobileReturning)) *
                  100
                ).toLocaleString()} %`,
                (data?.MobileNew + data?.MobileReturning)?.toLocaleString(),
                data?.TotalCorrectInvoices?.toLocaleString(),
                data?.TotalInvoices?.toLocaleString(),
                `${((data?.TotalCorrectInvoices / data?.TotalInvoices) * 100).toFixed(2)} %`,
              ]
            })
          : data,
        foot: footerData ? [footerData] : [],
        styles: {
          fontSize: 8,
          halign: 'center',
        },
        startY: 25,
        showFoot: 'lastPage',
      })
    }

    // Event to trigger on each page
    const didDrawPage = () => {
      addContent()
    }

    doc.setDrawColor(0) // Set draw color to black
    doc.setLineWidth(0.5) // Set line width

    doc.autoTable({
      head: [],
      body: [],
      didDrawPage: didDrawPage,
    })

    addTableContent()

    doc.save(
      `${moment(startDate).format('YYYY-MM-DD')}-to-${moment(endDate).format(
        'YYYY-MM-DD',
      )}-NewReturningAnalysis.pdf`,
    )
  }

  const getTotals = () => {
    try {
      setDefaultData(allNewReturningAnalysis)

      setNewCustomersTotal(
        allNewReturningAnalysis?.reduce((a, b) => {
          return a + b?.MobileNew
        }, 0),
      )

      setNewCusPerTotal(
        (
          (allNewReturningAnalysis?.reduce((a, b) => {
            return a + b?.MobileNew
          }, 0) /
            (allNewReturningAnalysis?.reduce((a, b) => {
              return a + b?.MobileNew
            }, 0) +
              allNewReturningAnalysis?.reduce((a, b) => {
                return a + b?.MobileReturning
              }, 0))) *
          100
        )?.toLocaleString(),
      )

      setReturningCustomerTotal(
        allNewReturningAnalysis?.reduce((a, b) => {
          return a + b?.MobileReturning
        }, 0),
      )

      setRetCusPerTotal(
        (
          (allNewReturningAnalysis?.reduce((a, b) => {
            return a + b?.MobileReturning
          }, 0) /
            (allNewReturningAnalysis?.reduce((a, b) => {
              return a + b?.MobileNew
            }, 0) +
              allNewReturningAnalysis?.reduce((a, b) => {
                return a + b?.MobileReturning
              }, 0))) *
          100
        )?.toLocaleString(),
      )

      setTotalRegCusCount(
        allNewReturningAnalysis?.reduce((a, b) => {
          return a + b?.MobileNew
        }, 0) +
          allNewReturningAnalysis?.reduce((a, b) => {
            return a + b?.MobileReturning
          }, 0),
      )

      setTotalRegTransCount(
        allNewReturningAnalysis?.reduce((a, b) => {
          return a + b?.TotalCorrectInvoices
        }, 0),
      )

      setTotalTransCount(
        allNewReturningAnalysis?.reduce((a, b) => {
          return a + b?.TotalInvoices
        }, 0),
      )

      setTotalTransPercent(
        (
          (allNewReturningAnalysis?.reduce((a, b) => {
            return a + b?.TotalCorrectInvoices
          }, 0) /
            allNewReturningAnalysis?.reduce((a, b) => {
              return a + b?.TotalInvoices
            }, 0)) *
          100
        ).toFixed(2),
      )
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setDefaultData(allNewReturningAnalysis)
    getTotals()
  }, [allNewReturningAnalysis])
  console.log('DATA', defaultData)

  const getDataFunc = () => {
    setTableLoader(true)
    const startOfMonth = moment().startOf('month').format('YYYY-MM-DD')
    const endOfMonth = moment().endOf('month').format('YYYY-MM-DD')
    let payload
    if (getMode() == 'offline') {
      payload = {
        startDate: startDate,
        endDate: endDate,
        shopname: location,
      }
    } else if (getMode() == 'ecommerce') {
      payload = {
        startDate: startDate,
        endDate: endDate,
      }
    } else if (filterApplied) {
      payload = {
        startDate: startDate,
        endDate: endDate,
        shopname: location,
      }
    } else {
      payload = {
        startDate: startOfMonth,
        endDate: endOfMonth,
      }
    }
    dispatch({
      type: reportTypes.GET_NEWRETURNING_ANALYSIS,
      payload: null,
    })

    allNewReturningAnalysisMutateState.mutate(
      { ...payload },
      {
        onSuccess: () => {
          setTableLoader(false)
        },
      },
    )
  }
  useEffect(() => {
    getDataFunc()
  }, [])

  const columns = [
    {
      title: 'Sr.',
      dataIndex: 'key',
    },
    {
      title: 'Shop Name',
      dataIndex: 'shopname',
    },
    {
      title: 'New Customer',
      dataIndex: 'MobileNew',
      sorter: {
        compare: (a, b) => a.MobileNew - b.MobileNew,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'MobileNew' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('MobileNew', sortedInfo.order),
      }),
    },
    {
      title: 'New Invoices',
      dataIndex: 'NewInvoices',
      sorter: {
        compare: (a, b) => a.NewInvoices - b.NewInvoices,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'NewInvoices' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('NewInvoices', sortedInfo.order),
      }),
    },
    {
      title: 'New Revenue',
      dataIndex: 'NewRevenue',
    },
    {
      title: 'New Cus %',
      dataIndex: 'newCustomersPercent',
      sorter: {
        compare: (a, b) => parseFloat(a.newCustomersPercent) - parseFloat(b.newCustomersPercent),
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'newCustomersPercent' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('newCustomersPercent', sortedInfo.order),
      }),
    },
    {
      title: 'Ret Customer',
      dataIndex: 'MobileReturning',
      sorter: {
        compare: (a, b) => a.MobileReturning - b.MobileReturning,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'MobileReturning' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('MobileReturning', sortedInfo.order),
      }),
    },
    {
      title: 'Ret Invoices',
      dataIndex: 'ReturningInvoices',
      sorter: {
        compare: (a, b) => a.ReturningInvoices - b.ReturningInvoices,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'ReturningInvoices' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('ReturningInvoices', sortedInfo.order),
      }),
    },
    {
      title: 'Ret Revenue',
      dataIndex: 'RetRevenue',
    },
    {
      title: 'Ret Cus %',
      dataIndex: 'returningCustomersPercent',
      sorter: {
        compare: (a, b) =>
          parseFloat(a.returningCustomersPercent) - parseFloat(b.returningCustomersPercent),
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'returningCustomersPercent' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('returningCustomersPercent', sortedInfo.order),
      }),
    },
    {
      title: 'T. Reg. Cus',
      dataIndex: 'totalRegisterCustomer',
      sorter: {
        compare: (a, b) => a.totalRegisterCustomer - b.totalRegisterCustomer,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'totalRegisterCustomer' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('totalRegisterCustomer', sortedInfo.order),
      }),
    },
    {
      title: 'T. Reg. Trans',
      dataIndex: 'TotalCorrectInvoices',
      sorter: {
        compare: (a, b) => a.TotalCorrectInvoices - b.TotalCorrectInvoices,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'TotalCorrectInvoices' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('TotalCorrectInvoices', sortedInfo.order),
      }),
    },
    {
      title: 'T. Trans',
      dataIndex: 'TotalInvoices',
      sorter: {
        compare: (a, b) => a.TotalInvoices - b.TotalInvoices,
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'TotalInvoices' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('TotalInvoices', sortedInfo.order),
      }),
    },
    {
      title: '% of Trans wd No.',
      dataIndex: 'transactionPercent',
      sorter: {
        compare: (a, b) => parseFloat(a.transactionPercent) - parseFloat(b.transactionPercent),
        multiple: 3,
      },
      sortOrder: sortedInfo.columnKey === 'transactionPercent' && sortedInfo.order,
      onHeaderCell: () => ({
        onClick: () => handleSort('transactionPercent', sortedInfo.order),
      }),
    },
  ]

  const tableLoading = {
    spinning: tableLoader,
    indicator: <LoadingOutlined style={{ color: 'var(--primary)' }} />,
  }

  return (
    <div>
      <div>
        <Header />
        <BackToPreviews />
        <div className='campaign-tabs campaign-container'>
          <div
            style={{
              fontSize: 16,
              marginTop: -50,
            }}
          >
            <h2>Consolidated Reports - New & Returning Analysis</h2>
          </div>

          <div className='report-filter'>
            <Row
              gutter={[5, 20]}
              className='graph-card'
              style={{ marginBottom: '2.5rem', width: '100%' }}
            >
              <Col xs={24} md={6} xl={3}>
                <div className='more-filter'>
                  <NewRetFilterDrawer
                    loaderBtn={allNewReturningAnalysisMutateState.isLoading || advenceSerach}
                    setAdvenceSerach={setAdvenceSerach}
                    setTableLoader={setTableLoader}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    setLocation={setLocation}
                    location={location}
                    setFilterApplied={setFilterApplied}
                    getMode={getMode()}
                    startDate={moment(startDate)}
                    endDate={endDate}
                    reportTypes={reportTypes}
                  />
                </div>
              </Col>

              <Col
                xs={24}
                xl={3}
                style={{
                  padding: 0,
                  marginLeft: '0.2rem',
                }}
              >
                <CSVLink
                  disabled={!defaultData?.length}
                  data={
                    defaultData
                      ? defaultData?.map((data, index) => ({
                          key: index + 1,
                          shopname: data?.shopName,
                          MobileNew: data?.MobileNew,
                          NewInvoices: data?.NewInvoices,
                          NewRevenue: 'Rs. ' + data?.new_revenue?.toLocaleString(),
                          RetRevenue:
                            'Rs. ' + (data?.total_revenue - data?.new_revenue)?.toLocaleString(),
                          newCustomersPercent: `${(
                            (data?.MobileNew / (data?.MobileNew + data?.MobileReturning)) *
                            100
                          ).toFixed(1)} %`,
                          MobileReturning: data?.MobileReturning?.toLocaleString(),
                          ReturningInvoices: data?.ReturningInvoices?.toLocaleString(),
                          returningCustomersPercent: `${(
                            (data?.MobileReturning / (data?.MobileNew + data?.MobileReturning)) *
                            100
                          ).toFixed(1)} %`,
                          totalRegisterCustomer: (
                            data?.MobileNew + data?.MobileReturning
                          )?.toLocaleString(),
                          TotalCorrectInvoices: data?.TotalCorrectInvoices?.toLocaleString(),
                          TotalInvoices: data?.TotalInvoices?.toLocaleString(),
                          transactionPercent: `${(
                            (data?.TotalCorrectInvoices / data?.TotalInvoices) *
                            100
                          ).toFixed(1)} %`,
                        }))
                      : []
                  }
                  headers={[
                    { label: 'Sr.', key: 'key' },
                    { label: 'Shop Name', key: 'shopname' },
                    { label: 'New Customer', key: 'MobileNew' },
                    { label: 'New Invoices', key: 'NewInvoices' },
                    { label: 'New Revenue', key: 'NewRevenue' },
                    { label: 'New Cus. %', key: 'newCustomersPercent' },
                    { label: 'Returning Customer', key: 'MobileReturning' },
                    { label: 'Returning Invoices', key: 'ReturningInvoices' },
                    { label: 'Ret Revenue', key: 'RetRevenue' },
                    { label: 'Ret Cus %', key: 'returningCustomersPercent' },
                    { label: 'T. Reg. Cus', key: 'totalRegisterCustomer' },
                    { label: 'T. Reg. Trans', key: 'TotalCorrectInvoices' },
                    { label: 'T. Trans', key: 'TotalInvoices' },
                    { label: '% of Trans wd No.', key: 'transactionPercent' },
                  ]}
                  filename={`${moment(startDate).format('YYYY-MM-DD')}-to-${moment(endDate).format(
                    'YYYY-MM-DD',
                  )}-NewReturningAnalysis.csv`}
                >
                  <Button type='primary' className='btn-primary btn-primary-glow'>
                    Export to CSV
                  </Button>
                </CSVLink>
              </Col>

              <Col
                xs={24}
                xl={3}
                style={{
                  padding: 0,
                  marginLeft: '0.5rem',
                }}
              >
                <Button
                  type='primary'
                  className='btn-primary btn-primary-glow'
                  onClick={() => {
                    exportToPDF(
                      defaultData?.map((data, index) => {
                        return [
                          index + 1,
                          data?.shopName,
                          data?.MobileNew,
                          data?.NewInvoices,
                          // data?.new_revenue,
                          'Rs. ' + data?.new_revenue?.toLocaleString(),
                          `${(
                            (data?.MobileNew / (data?.MobileNew + data?.MobileReturning)) *
                            100
                          ).toLocaleString()} %`,
                          data?.MobileReturning?.toLocaleString(),
                          data?.ReturningInvoices?.toLocaleString(),
                          'Rs. ' + (data?.total_revenue - data?.new_revenue)?.toLocaleString(),
                          `${(
                            (data?.MobileReturning / (data?.MobileNew + data?.MobileReturning)) *
                            100
                          ).toLocaleString()} %`,
                          (data?.MobileNew + data?.MobileReturning)?.toLocaleString(),
                          data?.TotalCorrectInvoices?.toLocaleString(),
                          data?.TotalInvoices?.toLocaleString(),
                          `${((data?.TotalCorrectInvoices / data?.TotalInvoices) * 100).toFixed(
                            2,
                          )} %`,
                        ]
                      }),
                      footerData,
                    )
                  }}
                >
                  Export to PDF
                </Button>
              </Col>

              <Col xs={24}>
                <Table
                  id={'tableHour'}
                  columns={columns}
                  loading={tableLoading}
                  style={{ marginTop: '1rem' }}
                  dataSource={defaultData?.map((data, index) => ({
                    key: index + 1,
                    shopname: data?.shopName,
                    MobileNew: data?.MobileNew,
                    NewInvoices: data?.NewInvoices,
                    NewRevenue: 'Rs. ' + data?.new_revenue?.toLocaleString(),
                    RetRevenue:
                      'Rs. ' + (data?.total_revenue - data?.new_revenue)?.toLocaleString(),

                    newCustomersPercent: `${(
                      (data?.MobileNew / (data?.MobileNew + data?.MobileReturning)) *
                      100
                    ).toFixed(1)} %`,
                    MobileReturning: data?.MobileReturning?.toLocaleString(),
                    ReturningInvoices: data?.ReturningInvoices?.toLocaleString(),
                    returningCustomersPercent: `${(
                      (data?.MobileReturning / (data?.MobileNew + data?.MobileReturning)) *
                      100
                    ).toFixed(1)} %`,
                    totalRegisterCustomer: (
                      data?.MobileNew + data?.MobileReturning
                    )?.toLocaleString(),
                    TotalCorrectInvoices: data?.TotalCorrectInvoices?.toLocaleString(),
                    TotalInvoices: data?.TotalInvoices?.toLocaleString(),
                    transactionPercent: `${(
                      (data?.TotalCorrectInvoices / data?.TotalInvoices) *
                      100
                    ).toFixed(1)} %`,
                  }))}
                  pagination={true}
                  scroll={{ x: 'auto' }}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewReturningAnalysisList
